module.exports = __webpack_public_path__ + "static/media/tick-mark-green-16x12.99b297a7.svg";